import { DESIGN_SYSTEM_VERSION_CSS_VARIABLE_NAME } from '../constants';
import { getDesignSystemVersion } from './getDesignSystemVersion';
function getComponentsLibraryVersionCssVariable() {
  return `--${DESIGN_SYSTEM_VERSION_CSS_VARIABLE_NAME}: "${getDesignSystemVersion()}";`;
}
export { getComponentsLibraryVersionCssVariable };